import { NavLink } from 'react-router-dom'

// Bottom tab bar — spec §5. Three tabs only:
//   Book a pickup / My orders / Account
// Rendered by Layout on the three connected-app routes.
export default function CustomerNav() {
  return (
    <nav
      className="fixed inset-x-0 bottom-0 z-30 mx-auto flex max-w-md items-stretch border-t border-line bg-white"
      style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}
    >
      <Tab to="/order"      icon="🧺" label="Book" />
      <Tab to="/my-orders"  icon="📦" label="My orders" />
      <Tab to="/account"    icon="👤" label="Account" />
    </nav>
  )
}

function Tab({ to, icon, label }) {
  return (
    <NavLink
      to={to}
      end
      className={({ isActive }) =>
        `flex flex-1 flex-col items-center justify-center gap-0.5 py-2 text-[10px] font-bold ${
          isActive ? 'text-navy' : 'text-ink-3'
        }`
      }
    >
      <span aria-hidden className="text-[18px] leading-none">{icon}</span>
      <span>{label}</span>
    </NavLink>
  )
}
